/**
 * local icons
 */

import 'bootstrap-icons/icons/file-earmark-arrow-down.svg';
import 'bootstrap-icons/icons/file-earmark-pdf.svg';
import 'bootstrap-icons/icons/file-earmark-zip.svg';
import 'bootstrap-icons/icons/file-earmark-text.svg';
import 'bootstrap-icons/icons/file-earmark-image.svg';
import 'bootstrap-icons/icons/file-earmark-play.svg';
import 'bootstrap-icons/icons/file-earmark-music.svg';

require.context('./icons/', true, /\.svg$/);

/**
 * JS
 */
import { UiIcon } from 'kk-web-components';

import './js/swiper'; // slider
import './js/chocolat'; // lightbox
import './js/loading-states';
import './js/bootstrap';
import './js/nav';
import './js/usp-count';
